module.exports = __webpack_public_path__ + "media/images/summit-2-3bfe9cc303c6fc216c357033e00eaaf4.jpg";